module.exports = __webpack_public_path__ + "img/massad.a1a60205.svg";